import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import { dotPath } from 'ramdasauce'
import { Media } from 'gatsby-plugin-fresnel'
import { useMedia } from 'react-use'

import { useStyles } from './styles'
import { Text, RichText, Animated } from 'components/atoms'

export const ContactHero = ({ data }) => {
  const classes = useStyles()

  const image = dotPath('data.backgroundImage', data)
  const title = dotPath('data.title', data)
  const subtitle = dotPath('data.rawSubtitle', data)

  const isDesktop = useMedia('(min-width: 1280px)')

  return (
    <Animated type={isDesktop ? 'fade-right' : 'fade-in'}>
      <div className={classes.wrapper}>
        <Media greaterThanOrEqual="desktop">
          <div className={classes.desktopLinks}>
            <div className={classes.linkColumn}>
              <Text size="label" className={classes.label}>
                SOCIAL
              </Text>
              <a
                href={dotPath('links.instagramLink', data)}
                className={classes.link}
                target="_blank"
                rel="noreferrer"
              >
                <Text size="label">Instagram</Text>
              </a>
              <a
                href={dotPath('links.youtubeLink', data)}
                className={classes.link}
                target="_blank"
                rel="noreferrer"
              >
                <Text size="label">YouTube</Text>
              </a>
            </div>
            <div className={classes.linkColumn}>
              <Text size="label" className={classes.label}>
                EMAIL
              </Text>
              <a
                href={`mailto:${dotPath('links.emailAddress', data)}`}
                className={classes.link}
              >
                <Text size="label">hello@designvanwa.com</Text>
              </a>
            </div>
          </div>
        </Media>
        <div className={classes.imageWrapper}>
          <GatsbyImage
            image={getImage(image.asset)}
            className={classes.image}
            alt={dotPath('title', image)}
          />
          <div className={classes.filter} />
          <Media lessThan="desktop">
            <Text tag="h1" size="header5" className={classes.title}>
              {title}
            </Text>
          </Media>
        </div>
        <div className={classes.textBlock}>
          <Media greaterThanOrEqual="desktop">
            <Text tag="h1" size="header5" className={classes.bodyTitle}>
              {title}
            </Text>
          </Media>
          <Text tag="h2" size="body2">
            <RichText data={subtitle} className={classes.subtitle} />
          </Text>
        </div>
      </div>
    </Animated>
  )
}
